export default "__VITE_ASSET__CKF$Mq4r__"